import type {Code} from 'services/codelists/types';

export const expressionFormat: Code[] = [
  {
    code: 'TEXT',
    value: 'Tekst',
  },
  {
    code: 'ILLUSTRATED_TEXT',
    value: 'Illustrert tekst',
  },
  {
    code: 'AUDIO',
    value: 'Lyd',
  },
];
